/**
 * Imperative helper for opening the AutoMapa WhatsApp widget shell.
 * M1: FAB. M2: vehicle CTAs with listing context.
 *
 * Uses a cancelable CustomEvent so callers can detect whether a mounted
 * widget handled the open (listener calls preventDefault).
 */
export const AUTOMAP_WHATSAPP_WIDGET_OPEN_EVENT = "automap:whatsapp-widget-open";
export const AUTOMAP_WHATSAPP_WIDGET_CLOSE_EVENT = "automap:whatsapp-widget-close";

export function openAutomapWhatsappWidget(context = null) {
  if (typeof window === "undefined") {
    return false;
  }
  const event = new CustomEvent(AUTOMAP_WHATSAPP_WIDGET_OPEN_EVENT, {
    detail: context && typeof context === "object" ? context : null,
    cancelable: true,
  });
  window.dispatchEvent(event);
  return event.defaultPrevented;
}

export function closeAutomapWhatsappWidget() {
  if (typeof window === "undefined") {
    return false;
  }
  window.dispatchEvent(new CustomEvent(AUTOMAP_WHATSAPP_WIDGET_CLOSE_EVENT));
  return true;
}
